import React from 'react';
import { Redirect } from 'react-router-dom';

import { PARENT_CONTACT_DETAILS_ROUTE } from '../../../../_configuration';

// Keeps already-sent `/athlete/:code/contacts` welcome-email and intro-SMS links
// alive after the code-gated public page was retired. The code is dropped — the
// parent app scopes contacts by the signed-in parent, not by a player code.
export const LegacyContactsRedirect: React.FC = () => <Redirect to={PARENT_CONTACT_DETAILS_ROUTE} />;
